import { Platform } from 'react-native';
import { BLACK, BLACK_500 } from './colors';
export var DISTANT = Platform.select({
  web: {
    shadowColor: BLACK,
    shadowOffset: {
      width: 0,
      height: 6
    },
    shadowOpacity: 0.05,
    shadowRadius: 16,
    elevation: 10
  },
  ios: {
    shadowColor: BLACK,
    shadowOffset: {
      width: 0,
      height: 4
    },
    shadowOpacity: 0.08,
    shadowRadius: 10,
    elevation: 10
  },
  android: {
    shadowColor: BLACK_500,
    elevation: 20
  }
});